module.exports = __webpack_public_path__ + "media/images/talent/lp/case06-b673cdaac1095c2ffeee4ebc447ddafd.png";